import { useQuery } from '@tanstack/react-query'
import { listMcpOauthConnections } from '@/lib/api/features/mcp-oauth-connections'

export const MCP_OAUTH_CONNECTIONS_QUERY_KEY = [
  'mcp-oauth-connections',
] as const

export function useMcpOauthConnections() {
  return useQuery({
    queryKey: MCP_OAUTH_CONNECTIONS_QUERY_KEY,
    queryFn: listMcpOauthConnections,
  })
}
